export default function() {
    return {
        items: {
            data: [],
            columns: [
                { name: '', align: 'left', label: "", field: row => row.TYPE, },
                { name: 'ACTIVE', label: "ACTIVE", field: row => row.ACTIVE,align: 'center'},
                { name: 'UPCOMING', label: "UPCOMING", field: row => row.UPCOMING,align: 'center' },
                { name: 'COMPLETED', label: "COMPLETED", field: row => row.COMPLETED, align: 'center'},
                { name: 'COMPLETED_SESSIONS', label: "COMPLETED SESSIONS", field: row => row.COMPLETED_SESSIONS,align: 'center'},

            ],
            pagination: {
                sortBy: '',
                descending: false,
                page: 1,
                rowsPerPage: 10,
                totalRecords: 0
            },
            filter: {
                search: "",
                customers: [],
                status: null,
                pickerDates: {
                    startDate: "",
                    endDate: "",
                  },
            },
            lastUpdated: '',
        },
        avg_calc: {
            Avg_Coach_rating: "",
            Avg_Session: "",
            Avg_shift: "",
            length: "",
        }
    }
}
